module.exports = {
  TABLE_LOAD_DATA: 'TABLE_LOAD_DATA',
  TABLE_LOAD_DATA_SUCCESS: 'TABLE_LOAD_DATA_SUCCESS',
  TABLE_LOAD_DATA_FAILURE: 'TABLE_LOAD_DATA_FAILURE',
  TABLE_CLEAR_DATA: 'TABLE_CLEAR_DATA',
  TABLE_SET_ACTIVE_FILTER: 'TABLE_SET_ACTIVE_FILTER',
  TABLE_CUSTOM_FILTER_CLEAR: 'TABLE_CUSTOM_FILTER_CLEAR',
  SET_TABLE_CHECKED_ITEMS: 'SET_TABLE_CHECKED_ITEMS',
  TABLE_CLICKED_ROW: 'TABLE_CLICKED_ROW',
  TABLE_TOGGLE_ALL: 'TABLE_TOGGLE_ALL',
  TABLE_TOGGLE_SELECTION: 'TABLE_TOGGLE_SELECTION',
  SET_TABLE_FILTERED_DATA: 'SET_TABLE_FILTERED_DATA',
  TRIGGER_TABLE_RELOAD: 'TRIGGER_TABLE_RELOAD',
  UPDATE_BLOCK_ROUTING: 'BLOCK_ROUTING',
};
